export class KafkaPartitioningConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "strategy",
            "baseName": "strategy",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KafkaPartitioningConfig.attributeTypeMap;
    }
    constructor() {
    }
}
